<template>
  <div v-if="cart" class="cart">
    <template v-if="!isEmpty && cart && cart.paid === false">
      <!-- Registrations -->
      <template v-if="cart.registrations && cart.registrations.length > 0">
        <h3>Inscriptions</h3>
        <div
            v-for="registration in cart.registrations"
            class="entry-container"
            :key="registration.id"
        >
          <cart-registration :registration="registration"/>
        </div>
      </template>

      <!-- Products -->
      <template v-if="cart.products && cart.products.length > 0">
        <h3>Produits</h3>
        <div
            v-for="product in cart.products"
            class="entry-container"
            :key="product.id"
        >
          <cart-product :entry="product" :is-paid="isPaid"/>
        </div>
      </template>

      <br/><br/><br/><br/>

      <!-- Total -->
      <div class="entry-container" style="justify-content: right; margin-bottom: 30px;">
        <p class="text-right">
          <b>Total</b> : {{ cart.total | money }}
        </p>
      </div>

      <div
          class="entry-container cart__payment"
          style="justify-content: right"
          v-if="
          ((cart.registrations && cart.registrations.length > 0) ||
            (cart.products && cart.products.length > 0)) &&
            cart.paid !== true
        "
      >
        <template v-if="cart.total > 0">
          <a class="btn btn-primary" @click="showCreditCard()">
            <template v-if="loading">
              <font-awesome-icon icon="spinner" spin/>
            </template>
            <template v-else>
              Payer mon panier par carte de crédit
            </template>
          </a>
        </template>
        <template v-else>
          <b-button variant="primary" @click="confirmFreeCart()">
            Finaliser la transaction gratuite
          </b-button>
        </template>
      </div>
    </template>

    <!-- If paid with Stripe -->
    <template v-else-if="cart && cart.total === 0 && isPaid">
      <h3>Merci pour votre commande !</h3>
      <br/>
      Votre commande a été payée avec succès.
      <br/><br/>
      Vous allez recevoir un courriel avec le résumé de la commande. Dans
      celui-ci, vous trouverez les informations suivantes :
      <br/><br/>
      <ul>
        <li>Numéro de la commande</li>
        <li>Les articles de la commande</li>
        <li>Le montant payé</li>
      </ul>
      <br/>
      Merci!
    </template>

    <!-- Empty cart -->
    <template v-else>
      <p class="text-center">Le panier est vide.</p>
    </template>

  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex';

  import CartProduct from './Panier_Produits_Liste';
  import CartRegistration from './Panier_Inscription_Liste';
  import PanierPayer from '@/components/Panier/Panier_Payer.vue';

  export default {
    name: 'cart-container',
    components: { CartRegistration, CartProduct },
    data() {
      return {
        loading: false,
        isPaid: false,
        showCreditCardModal: false
      };
    },

    async beforeMount() {
      await this.getCart();
    },

    computed: {
      ...mapGetters('orders', {
        cart: 'cart'
      }),
      ...mapState({
        connected: state => state.account.status.loggedIn
      }),
      isEmpty() {
        if (!this.cart) {
          return true;
        }
        if (this.cart.registrations && this.cart.registrations.length > 0) {
          return false;
        }
        return !(this.cart.products && this.cart.products.length > 0);
      }
    },
    methods: {
      ...mapActions('orders', {
        getCart: 'getCart',
        processCart: 'processCart'
      }),

      async confirmFreeCart() {
        try {
          await this.processCart();
          await this.getCart();
          this.$swal.fire({
            title: 'Succès',
            text: "Votre commande a été enregistrée avec succès. Vous recevrez un courriel dans les prochaines minutes. Veuillez le lire attentivement parce qu'il peut contenir des informations importantes à propos de vos achats.",
            type: 'success',
            confirmButtonText: 'Fermer'
          });
        }
        catch (e) {
          console.error('Failed to process cart.', e);
          this.$swal.fire({
            title: 'Erreur',
            text: "Une erreur s'est produite lors du traitement du panier. Veuillez réessayer plus tard.",
            type: 'error'
          });
          throw e;
        }
        finally {
          this.loading = false;
        }
      },

      showCreditCard() {
        this.$modal.show(PanierPayer, {
          onSuccess: () => this.payCart(),
          title: 'Achat du panier'
        }, {
          height: 'auto',
          width: 500,
          clickToClose: false,
          name: 'cart-payment',
          root: this.$root
        });
      },

      /**
       * Retrieve the stripe session id and redirect to the Stripe Checkout page
       */
      async payCart() {
        this.$modal.hide('cart-payment');

        if (!this.loading) {
          this.loading = true;

          // Now process the cart
          try {
            await this.processCart();
            await this.getCart();
            this.$swal.fire({
              title: 'Succès',
              text: "Votre commande a été enregistrée avec succès. Vous recevrez un courriel dans les prochaines minutes. Veuillez le lire attentivement parce qu'il peut contenir des informations importantes à propos de vos achats.",
              type: 'success',
              confirmButtonText: 'Fermer'
            });
          }
          catch (e) {
            console.error(e);
            if (e.response) {
              // Build error html
              let html = "<p>Une erreur s'est produite lors du traitement du panier.</p><ul style='margin-bottom: 0'>";
              for (const i of e.response.data.message) {
                html += '<li style="margin-top: 10px; margin-bottom: 10px">' + i.message + '</li>';
              }
              html += '</ul>';

              this.$swal.fire({
                title: 'Erreur',
                html,
                type: 'error'
              });
            }
          }
          finally {
            this.loading = false;
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
.entry-container {
  display: flex;
  flex-direction: column;
}

.cart {
  p {
    margin-left: 0;
    padding-left: 0;
    margin-right: 0;
    width: 100%;
    padding-right: 0;
  }

  &__payment {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
  }
}

.btn {
  text-decoration: none !important;

  align-self: stretch;
  width: 99%;

  &:not(:first-child) {
    margin-left: 5px;
  }
}

.btn-primary {
  color: white !important;
}

.btn-outline-primary {
  color: #1a53ff !important;

  &:hover {
    color: white !important;
  }
}

.form-control {
  font-size: 12px;

  &:not(:first-child) {
    margin-left: 5px;
  }
}
</style>
